var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"routeleaf-logo",attrs:{"alt":"RouteLeaf Logo","width":_vm.width,"src":require('@/assets/img/routeleaf-logo-text-white.svg')},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }